import {
  SET_LIST_LOV_DATA,
  SET_RECEIPT_DETAIL_DATA,
  SET_RECEIPT_LIST_DATA,
} from './constants';

export const initialState = {
  listLov: {},
  receiptList: {},
  receiptDetail: {},
};

const feeReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_RECEIPT_LIST_DATA:
      state = {
        ...state,
        receiptList: payload,
      };
      break;
    case SET_LIST_LOV_DATA:
      if (payload?.data?.content) {
        let filterLov = [];
        if (payload.data.content.length > 0) {
          filterLov = payload.data.content.filter((item) => {
            if (
              item?.type === 'PMT_TYP' ||
              (item?.type === 'PREM_STAT' &&
                item?.code !== '3' &&
                item?.code !== '4' &&
                item?.code !== '2' &&
                item?.code !== '0') ||
              (item?.type === 'RECPT_STAT' &&
                item?.code !== 'Refunded' &&
                item?.code !== 'Reverted')
            ) {
              return true;
            }
            if (item?.dataConfig?.sourceSystem?.length > 0) {
              return item?.dataConfig?.sourceSystem?.includes('SNPRTL');
            }
            return false;
          });
        }
        const result = Object.groupBy(filterLov, ({ type }) => type);
        console.log(result);
        if (result?.PREM_STAT && result.PREM_STAT.length > 0) {
          result.PREM_STAT.push({
            id: null,
            type: 'PREM_STAT',
            code: 'all',
            enName: 'Refunded',
            vnName: 'Tất cả',
            extendProperty: null,
            dataConfig: null,
          });
        }
        if (result?.RECPT_STAT && result.RECPT_STAT.length > 0) {
          result.RECPT_STAT.push({
            id: null,
            type: 'RECPT_STAT',
            code: 'all',
            enName: 'Refunded',
            vnName: 'Tất cả',
            extendProperty: null,
            dataConfig: null,
          });
        }
        if (result?.PMT_TYP && result.PMT_TYP.length > 0) {
          result.PMT_TYP.push({
            id: null,
            type: 'PMT_TYP',
            code: 'all',
            enName: 'Refunded',
            vnName: 'Tất cả',
            extendProperty: null,
            dataConfig: null,
          });
        }
        state = {
          ...state,
          listLov: result,
        };
      }
      break;
    case SET_RECEIPT_DETAIL_DATA:
      state = {
        ...state,
        receiptDetail: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default feeReducers;
